export enum FormFieldTypes {
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  MiddleName = 'middleName',
  Organization = 'organization',
  Password = 'password',
  Phone = 'phone',
  Position = 'position',
  PostStudent = 'postStudent',
  PostStudentOrTeacher = 'postStudentOrTeacher',
  Staff = 'staff',
  Taxation = 'taxation',
  University = 'university',
  ActivationOfUKD = 'activationCodes',
  Code = 'code',
  SmsCode = 'smsCode',
  Mode = 'mode',
  BirthDate = 'birthDate',
  Branch = 'branch',
  Region = 'regionId',
  Institute = 'instituteId',
  Specialty = 'specialtyId',
  Degree = 'degreeId',
}
